const values = [
  "GenPack_14000_gem",
  "GenPack_6000_gem",
  "ResourcePack_01",
];
export default values;
